import type { ProcessingJob } from "features/dt-plus-setup/model/types";

import { useTranslation } from "react-i18next";

import { useTransientJobConfig } from "../hooks/useTransientJobConfig";
import { parseNumericId } from "../lib/parseApiId";
import { TransientJobConfigValue } from "./TransientJobConfigValue";

type TransientJobConfigSummaryProps = {
  job: ProcessingJob;
};

export const TransientJobConfigSummary = ({ job }: TransientJobConfigSummaryProps) => {
  const { t } = useTranslation();
  const configId = parseNumericId(job, ["config_id", "configId"]) ?? undefined;
  const { error, isLoading, rows } = useTransientJobConfig(configId);

  if (configId == null || (!isLoading && !error && rows.length === 0)) {
    return (
      <p className="font-ds-body-regular-md text-lds-foreground-muted">{t("Execution.transient.jobDetails.configEmpty")}</p>
    );
  }
  if (isLoading) {
    return <p className="font-ds-body-regular-md text-lds-foreground-muted">{t("general.loadingDataPleaseWait")}</p>;
  }
  if (error) {
    return <p className="text-lds-purpose-status-negative-subtle">{error}</p>;
  }

  return (
    <div className="grid w-full grid-cols-2 gap-x-12 gap-y-3">
      {rows.map((row) => (
        <TransientJobConfigValue key={row.label} label={row.label} value={row.value} />
      ))}
    </div>
  );
};
